"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Inbox/InboxList/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactredux = require('react-redux');

var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _session = require('shared/selectors/session');
var _blobject = require('shared/selectors/blobject');




var _user = require('shared/selectors/user');
var _team = require('shared/selectors/team');
var _chat = require('shared/enum/chat');












var _inbox = require('shared/hooks/inbox');
var _actionCreators = require('shared/actions/actionCreators'); var _actionCreators2 = _interopRequireDefault(_actionCreators);
var _useBus = require('shared/hooks/useBus'); var _useBus2 = _interopRequireDefault(_useBus);
var _requests = require('shared/hooks/requests');
var _utils = require('shared/hooks/inbox/useInbox/utils');
var _noticeBar = require('web/services/context/noticeBar');
var _hooks = require('web/services/hooks');

var _List = require('web/screens/App/List');
var _ItemsList = require('./ItemsList'); var _ItemsList2 = _interopRequireDefault(_ItemsList);
var _NewChatListItemPlaceholder = require('./NewChatListItemPlaceholder'); var _NewChatListItemPlaceholder2 = _interopRequireDefault(_NewChatListItemPlaceholder);
var _ListResultsStatus = require('web/components/ListResultsStatus'); var _ListResultsStatus2 = _interopRequireDefault(_ListResultsStatus);
var _Header = require('./Header'); var _Header2 = _interopRequireDefault(_Header);
var _InboxTabs = require('./InboxTabs'); var _InboxTabs2 = _interopRequireDefault(_InboxTabs);
var _ArchivedBar = require('./ArchivedBar'); var _ArchivedBar2 = _interopRequireDefault(_ArchivedBar);
var _ListSearchField = require('./ListSearchField'); var _ListSearchField2 = _interopRequireDefault(_ListSearchField);
var _EmptyInbox = require('./EmptyInbox'); var _EmptyInbox2 = _interopRequireDefault(_EmptyInbox);
var _useDragGuard = require('./useDragGuard');
var _PinLimitToast = require('./PinLimitToast'); var _PinLimitToast2 = _interopRequireDefault(_PinLimitToast);

// Unread lists the chats still unread, and the open one even once it's read,
// so opening a chat doesn't pull its row away; it goes when you move on.
const selectUnreadOrOpenKeys = (
  state,
  keys,
  myUserKey,
  openBlobjectKey,
) => keys.filter(k => {
  const b = state.dataV2.blobjects[k]
  return k === openBlobjectKey || !b || _utils.isUnreadForMe.call(void 0, b, myUserKey)
})

// The Scheduled list follows its messages: one sent or cancelled can take a
// chat off it, one scheduled can add one.
const SCHEDULED_CHANGE_ACTIONS = [_actionCreators2.default.scheduledMessageUpdateNotificationAction.type]
// The Requests list reloads with the open requests, which may name a chat it
// hasn't loaded yet.
const REQUESTS_CHANGE_ACTIONS = [_actionCreators2.default.getOpenRequestsActions.SUCCESS.type]
const NO_ACTIONS = []

const listChangeActions = (tab) => {
  if (tab === _inbox.InboxTab.SCHEDULED) return SCHEDULED_CHANGE_ACTIONS
  if (tab === _inbox.InboxTab.REQUESTS) return REQUESTS_CHANGE_ACTIONS
  return NO_ACTIONS
}











const InboxList = ({
  onCreateNewChat,
  isCreatingNewChat,
  onCloseCreateNewChat,
  isViewingCreateNewChat,
  onReopenNewChat,
  isDraftOpen = false,
}) => {
  const selectedTeamKey = _hooks.useAppSelector.call(void 0, _session.selectSelectedTeamKey)
  const myUserKey = _hooks.useAppSelector.call(void 0, _user.selectCurrentUserKey)
  const myInboxableTeamKeys = _hooks.useAppSelector.call(void 0, _blobject.selectMyInboxableTeamKeys)
  const canSeePatients = _hooks.useAppSelector.call(void 0, state => !!_user.selectCurrentUserHasPatientMessagingFeature.call(void 0, state))
  const canTextPatient = _hooks.useAppSelector.call(void 0, state => !!_user.selectCurrentUserHasCreateNewFeature.call(void 0, state)) && canSeePatients
  const teamName = _hooks.useAppSelector.call(void 0, state =>
    (selectedTeamKey && _optionalChain([_team.selectTeamByKey.call(void 0, state, selectedTeamKey), 'optionalAccess', _ => _.Name])) || null)
  const inboxName = teamName || 'My Inbox'

  const { showSuccessBar, showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  const onError =
    _react.useCallback.call(void 0, () => showWarningBar('Failed to load Inbox'), [showWarningBar])

  const {
    activeFilter,
    setActiveFilter,
    activeTab,
    setActiveTab,
    blobjectKeysList,
    isLoading,
    hasDrained,
    onLoadMore,
    onSilentReset: onReset,
  } = _inbox.useInbox.call(void 0, { selectedTeamKey, myInboxableTeamKeys, myUserKey, onError })
  const openBlobjectKey = _ItemsList.useOpenBlobjectKey.call(void 0, )
  const isUnreadTab = activeTab === _inbox.InboxTab.UNREAD
  const isRequestsTab = activeTab === _inbox.InboxTab.REQUESTS
  const isArchived = activeFilter === _inbox.BlobjectFilter.COMPLETED
  const listedKeys = _hooks.useAppSelector.call(void 0, 
    state => (isUnreadTab ? selectUnreadOrOpenKeys(state, blobjectKeysList, myUserKey, openBlobjectKey) : blobjectKeysList),
    _reactredux.shallowEqual,
  )
  const { blobjectKeys, requestsPill } =
    _requests.useRequestsTab.call(void 0, { teamKey: selectedTeamKey, activeTab, isArchived, listedKeys })

  const {
    isBlobjectBeingArchived,
    onToggleBlobjectArchived,
  } = _inbox.useArchiveTransaction.call(void 0, { activeFilter, onReset, showSuccessBar, showWarningBar })
  const onMarkUnread = _inbox.useMarkUnread.call(void 0, { showWarningBar })
  const { pinLimitText, showPinLimit } = _PinLimitToast.usePinLimitToast.call(void 0, )
  const onTogglePinned = _inbox.usePinBlobject.call(void 0, { showWarningBar, showPinLimit })

  // The tabs, with their counts, for this inbox and archive state.
  const counts = _inbox.useInboxCounts.call(void 0, { teamKey: selectedTeamKey, isArchived, canSeePatients })
  const pills = _react.useMemo.call(void 0, 
    () => _inbox.inboxPills.call(void 0, counts, canSeePatients, requestsPill),
    [counts, canSeePatients, requestsPill],
  )
  // A tab that empties (the last scheduled message sent) goes, and its list
  // with it. Only once the counts are in, so loading never moves you.
  // Requests needs no counts: it goes with KEYWORDS, and in Archived.
  const isActiveTabGone = (!!counts || isRequestsTab) && !pills.some(p => p.tab === activeTab)
  _react.useEffect.call(void 0, () => {
    if (isActiveTabGone) setActiveTab(_inbox.InboxTab.ALL)
  }, [isActiveTabGone, setActiveTab])
  _useBus2.default.call(void 0, listChangeActions(activeTab), onReset)

  const onToggleArchived = _react.useCallback.call(void 0, 
    () => setActiveFilter(isArchived ? _inbox.BlobjectFilter.ACTIVE : _inbox.BlobjectFilter.COMPLETED),
    [isArchived, setActiveFilter],
  )
  const onBackToActive = _react.useCallback.call(void 0, () => setActiveFilter(_inbox.BlobjectFilter.ACTIVE), [setActiveFilter])
  const onShowArchived = _react.useCallback.call(void 0, () => setActiveFilter(_inbox.BlobjectFilter.COMPLETED), [setActiveFilter])
  const onShowAll = _react.useCallback.call(void 0, () => setActiveTab(_inbox.InboxTab.ALL), [setActiveTab])
  const onTextPatient = _react.useCallback.call(void 0, () => onCreateNewChat(_chat.CHAT_TYPE.SECURE_PATIENT), [onCreateNewChat])

  const dragGuard = _useDragGuard.useDragGuard.call(void 0, )

  const resultsCount = blobjectKeys.length
  const isEmpty = !isLoading && !resultsCount && !isCreatingNewChat

  return (
    _react2.default.createElement(_List.List, { className: "inbox-list", ...dragGuard, __self: this, __source: {fileName: _jsxFileName, lineNumber: 163}}
      , _react2.default.createElement(_Header2.default, {
        selectedTeam: selectedTeamKey,
        onSelectTeam: _actions2.default.setSelectedTeam,
        onCreateNewChat: onCreateNewChat, __self: this, __source: {fileName: _jsxFileName, lineNumber: 164}}
      )
      , _react2.default.createElement('div', { className: "inbox-list--search-row", __self: this, __source: {fileName: _jsxFileName, lineNumber: 169}}
        , _react2.default.createElement(_ListSearchField2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 170}} )
        , _react2.default.createElement(_InboxTabs.ArchiveToggle, { isArchived: isArchived, onToggleArchived: onToggleArchived, __self: this, __source: {fileName: _jsxFileName, lineNumber: 171}} )
      )
      , _react2.default.createElement(_InboxTabs2.default, { pills: pills, activeTab: activeTab, onSelectTab: setActiveTab, __self: this, __source: {fileName: _jsxFileName, lineNumber: 173}} )
      ,  isArchived && _react2.default.createElement(_ArchivedBar2.default, { onBackToActive: onBackToActive, __self: this, __source: {fileName: _jsxFileName, lineNumber: 174}} ) 
      , _react2.default.createElement(_List.ListItemsWrapper, { className: "inbox-list-items", __self: this, __source: {fileName: _jsxFileName, lineNumber: 175}}
        /* New chat is a modal (or a draft in the right pane): its row shows
            only while another chat is open, as the way back to it. */
        ,  isCreatingNewChat && !isViewingCreateNewChat && (
          _react2.default.createElement(_NewChatListItemPlaceholder2.default, {
            onClick: onReopenNewChat,
            onCancel: onCloseCreateNewChat,
            isSelected: isViewingCreateNewChat, __self: this, __source: {fileName: _jsxFileName, lineNumber: 179}}
          )
        )
        , _react2.default.createElement(_ItemsList2.default, {
          blobjectKeys: blobjectKeys,
          activeFilter: activeFilter,
          onLoadMore: onLoadMore,
          hasMore: !!blobjectKeysList.length && !hasDrained,
          isBlobjectBeingArchived: isBlobjectBeingArchived,
          onToggleBlobjectArchived: onToggleBlobjectArchived,
          isSelectionHidden: isDraftOpen,
          onMarkUnread: onMarkUnread,
          onTogglePinned: onTogglePinned, __self: this, __source: {fileName: _jsxFileName, lineNumber: 185}}
        )
        ,  isEmpty && (
          _react2.default.createElement(_EmptyInbox2.default, {
            tab: activeTab,
            isArchived: isArchived,
            inboxName: inboxName,
            teamName: teamName,
            onShowAll: onShowAll,
            onShowArchived: onShowArchived,
            onTextPatient: canTextPatient ? onTextPatient : undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 197}}
          )
        )
        ,  activeTab === _inbox.InboxTab.UNREAD && hasDrained && !isLoading && !!resultsCount && (
          _react2.default.createElement('div', { className: "inbox-list--footnote", __self: this, __source: {fileName: _jsxFileName, lineNumber: 208}}, "That's every unread chat in "     ,  inboxName )
        )
        ,  isRequestsTab && hasDrained && !isLoading && !!resultsCount && (
          _react2.default.createElement('div', { className: "inbox-list--footnote", __self: this, __source: {fileName: _jsxFileName, lineNumber: 211}}, "That's every open request in "     ,  inboxName )
        )
        ,  isLoading && (
          _react2.default.createElement(_ListResultsStatus2.default, {
            isLoading: isLoading,
            resultsCount: resultsCount,
            noResultsLabel: "No chats found"  ,
            className: "inbox-list--result", __self: this, __source: {fileName: _jsxFileName, lineNumber: 214}}
          )
        )
      )
      , _react2.default.createElement(_PinLimitToast2.default, { text: pinLimitText, __self: this, __source: {fileName: _jsxFileName, lineNumber: 222}} )
    )
  )
}

exports. default = _react.memo.call(void 0, InboxList)
